/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResourcePermissionsResponse } from './ResourcePermissionsResponse';
import {
    ResourcePermissionsResponseFromJSON,
    ResourcePermissionsResponseFromJSONTyped,
    ResourcePermissionsResponseToJSON,
    ResourcePermissionsResponseToJSONTyped,
} from './ResourcePermissionsResponse';

/**
 * 
 * @export
 * @interface TeamBasic
 */
export interface TeamBasic {
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    clubName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    categoryName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    homeColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    awayColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    goalkeeperColor?: string;
    /**
     * 
     * @type {number}
     * @memberof TeamBasic
     */
    playersCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamBasic
     */
    officialsCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TeamBasic
     */
    receiptUploaded?: boolean;
    /**
     * 
     * @type {ResourcePermissionsResponse}
     * @memberof TeamBasic
     */
    permissions?: ResourcePermissionsResponse;
}

/**
 * Check if a given object implements the TeamBasic interface.
 */
export function instanceOfTeamBasic(value: object): value is TeamBasic {
    return true;
}

export function TeamBasicFromJSON(json: any): TeamBasic {
    return TeamBasicFromJSONTyped(json, false);
}

export function TeamBasicFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamBasic {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'clubName': json['clubName'] == null ? undefined : json['clubName'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'email': json['email'] == null ? undefined : json['email'],
        'status': json['status'] == null ? undefined : json['status'],
        'country': json['country'] == null ? undefined : json['country'],
        'state': json['state'] == null ? undefined : json['state'],
        'city': json['city'] == null ? undefined : json['city'],
        'homeColor': json['homeColor'] == null ? undefined : json['homeColor'],
        'awayColor': json['awayColor'] == null ? undefined : json['awayColor'],
        'goalkeeperColor': json['goalkeeperColor'] == null ? undefined : json['goalkeeperColor'],
        'playersCount': json['playersCount'] == null ? undefined : json['playersCount'],
        'officialsCount': json['officialsCount'] == null ? undefined : json['officialsCount'],
        'receiptUploaded': json['receiptUploaded'] == null ? undefined : json['receiptUploaded'],
        'permissions': json['permissions'] == null ? undefined : ResourcePermissionsResponseFromJSON(json['permissions']),
    };
}

export function TeamBasicToJSON(json: any): TeamBasic {
    return TeamBasicToJSONTyped(json, false);
}

export function TeamBasicToJSONTyped(value?: TeamBasic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'clubName': value['clubName'],
        'categoryId': value['categoryId'],
        'categoryName': value['categoryName'],
        'gender': value['gender'],
        'email': value['email'],
        'status': value['status'],
        'country': value['country'],
        'state': value['state'],
        'city': value['city'],
        'homeColor': value['homeColor'],
        'awayColor': value['awayColor'],
        'goalkeeperColor': value['goalkeeperColor'],
        'playersCount': value['playersCount'],
        'officialsCount': value['officialsCount'],
        'receiptUploaded': value['receiptUploaded'],
        'permissions': ResourcePermissionsResponseToJSON(value['permissions']),
    };
}

